import { useState } from 'react';
import { BrowserRouter, Routes, Route, NavLink, useNavigate } from 'react-router-dom';
import Home         from './pages/Home';
import Reservoir    from './pages/Reservoir';
import Barriere     from './pages/Barriere';
import FeuTricolore from './pages/FeuTricolore';
import Surveillance from './pages/Surveillance';
import Login        from './pages/Login';
import Admin        from './pages/Admin';
import Documents    from './pages/Documents';
import ConfigPanel  from './pages/ConfigPanel';
import ProtectedRoute from './components/ProtectedRoute';
import ReadOnlyGate from './components/ReadOnlyGate';
import ActiveApplicationGate from './components/ActiveApplicationGate';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ProgramIdentityProvider, useProgramIdentity } from './context/ProgramIdentityContext';

const applicationLinks = [
  { to: '/reservoir', application: 'reservoir', label: 'Gestion du Réservoir' },
  { to: '/barriere', application: 'barriere', label: 'Barrière Automatique' },
  { to: '/feu-tricolore', application: 'feu_tricolore', label: 'Feux Tricolores' },
  { to: '/surveillance', application: 'surveillance', label: 'Surveillance' },
];

export function Navbar() {
  const navigate = useNavigate();
  const { isAuthenticated, isAdmin, logout } = useAuth();
  const { isApplicationActive } = useProgramIdentity();
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  const handleLogout = () => {
    closeMenu();
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">

      <div className="navbar-brand">
        <img
          src="/meapulse.png"
          alt="MEA PULSE"
          className="brand-logo"
        />
      </div>

      <button
        type="button"
        className="navbar-toggle"
        aria-controls="primary-navigation"
        aria-expanded={menuOpen}
        aria-label={menuOpen ? 'Fermer le menu principal' : 'Ouvrir le menu principal'}
        onClick={() => setMenuOpen((open) => !open)}
      >
        <span aria-hidden="true" className="navbar-toggle-icon">
          {menuOpen ? '✕' : '☰'}
        </span>
        <span>Menu</span>
      </button>

      <div id="primary-navigation" className={`navbar-links ${menuOpen ? 'is-open' : ''}`}>
        <NavLink to="/" end onClick={closeMenu} className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Accueil</NavLink>
        {applicationLinks.map(({ to, application, label }) => {
          const enabled = isApplicationActive(application);
          return (
            <NavLink
              key={application}
              to={to}
              title={enabled ? undefined : 'Aperçu neutre — programme non chargé dans le PLC'}
              onClick={closeMenu}
              className={({isActive}) => [
                'nav-link',
                isActive ? 'active' : '',
              ].filter(Boolean).join(' ')}
            >
              {label}
            </NavLink>
          );
        })}
        <NavLink to="/documents" onClick={closeMenu} className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Documents</NavLink>
        {isAdmin && (
          <NavLink to="/admin" onClick={closeMenu} className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Administration</NavLink>
        )}
        {isAdmin && (
          <NavLink to="/configuration" onClick={closeMenu} className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Configuration</NavLink>
        )}
      </div>

      {isAuthenticated && (
        <div className="navbar-user">
          <button className="btn-logout" onClick={handleLogout}>Déconnexion</button>
        </div>
      )}
    </nav>
  );
}

function AppShell() {
  const { isAuthenticated } = useAuth();

  return (
    <div className="app">
      {isAuthenticated && <Navbar />}
      <main className="main-content">
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/" element={
            <ProtectedRoute><Home /></ProtectedRoute>
          } />
          <Route path="/reservoir" element={
            <ProtectedRoute><ReadOnlyGate><ActiveApplicationGate application="reservoir"><Reservoir /></ActiveApplicationGate></ReadOnlyGate></ProtectedRoute>
          } />
          <Route path="/barriere" element={
            <ProtectedRoute><ReadOnlyGate><ActiveApplicationGate application="barriere"><Barriere /></ActiveApplicationGate></ReadOnlyGate></ProtectedRoute>
          } />
          <Route path="/feu-tricolore" element={
            <ProtectedRoute><ReadOnlyGate><ActiveApplicationGate application="feu_tricolore"><FeuTricolore /></ActiveApplicationGate></ReadOnlyGate></ProtectedRoute>
          } />
          <Route path="/surveillance" element={
            <ProtectedRoute><ReadOnlyGate><ActiveApplicationGate application="surveillance"><Surveillance /></ActiveApplicationGate></ReadOnlyGate></ProtectedRoute>
          } />
          <Route path="/documents" element={
            <ProtectedRoute><Documents /></ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute requireAdmin><Admin /></ProtectedRoute>
          } />
          <Route path="/configuration" element={
            <ProtectedRoute requireAdmin><ConfigPanel /></ProtectedRoute>
          } />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ProgramIdentityProvider>
          <AppShell />
        </ProgramIdentityProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
